<template>
    <div id="modal" class="r-isfull-position">
        <div class="r-modal-box r-mtb-20-withauto">
            <div class="r-modal-header r-ptb-16 r-plr-25">
                <div class="r-center-flex">
                    <h5 class="r-mr-auto">Video Tutorial</h5>
                    <img :src="require('@/assets/icons/black/close.svg')" class="r-isClickAble" @click.prevent="closeModal()">
                </div>
            </div>
            <div class="r-modal-form r-ptb-16 r-plr-25">
                <iframe width="100%" height="260"  src='https://www.youtube.com/embed/L4cntmWcUKI' frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        closeModal(){
            this.$emit('closeModal')
        }
    }
}
</script>